import React from "react";
import studioData from "../data/studioData.json";
import { convertTextToLinks } from "../helpers/helper";

const Services = () => {
  const { services } = studioData;

  return (
    <section id="services" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="section-kicker">02 Services</p>
          <h2 className="section-title">End-to-end design delivery</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {services.map((exp, index) => (
          <article key={index} className="glass-card p-6 md:p-7">
            <p className="section-kicker !mb-3">{String(index + 1).padStart(2, "0")}</p>
            <h3 className="text-2xl font-medium text-white md:text-[1.7rem] md:leading-tight">
              {exp.title}
            </h3>
            <p className="mt-2 text-sm uppercase tracking-[0.12em] text-text-secondary">
              {exp.company}
            </p>
            <div className="mt-5 space-y-2 border-t border-white/15 pt-4 text-sm leading-relaxed text-text-secondary">
              {exp.responsibilities.map((res, i) => (
                <p key={i} className="flex gap-2">
                  <span className="text-white">/</span>
                  <span>{convertTextToLinks(res)}</span>
                </p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Services;
